export const load = () => {
  if(typeof window === "undefined" || typeof document === "undefined")
    return;

  /* eslint-disable */
  // NOTE: This tag has been modified from its original version
  // Args `t` and `s` have been added as undefined arguments to prevent attempts
  // to assign them as globals, which throws when `'use strict'` is specified
  !function(e,n,u,a,t,s){e.twq||(a=e.twq=function(){a.exe?a.exe.apply(a,arguments):
  a.queue.push(arguments);},a.version='1',a.queue=[],t=n.createElement(u),
  t.async=!0,t.src='//static.ads-twitter.com/uwt.js',s=n.getElementsByTagName(u)[0],
  s.parentNode.insertBefore(t,s))}(window,document,'script');
  /* eslint-enable */

  // Insert Twitter Pixel ID and Standard Event data below
  twq('init','nv6pe') // eslint-disable-line no-undef
}



// WEBPACK FOOTER //
// ./client/utility/twitter.js